import { Button, Input, Table, TableColumnsType } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";
import { sortIcon } from "components/Table";
import useUser from "hooks/passengers/usePassengers";
import { IUser } from "models/user";
import { useState } from "react";
import PassengerAction from "./PassengerDetail/components/Actions";
import EditPassengerModal from "./components/EditPassengerModal";

export default function Passenger() {
  const {
    data: { data, loading, page, per_page, search, total },
    handleSearch,
    handlePageChange,
    fetchData,
  } = useUser();

  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState<IUser | null>(null);

  const handleEdit = (user: IUser) => {
    setSelectedUser(user);
    setEditModalVisible(true);
  };

  const columns: TableColumnsType<IUser> = [
    {
      title: "USER PHOTO",
      dataIndex: "user_photo",
      render: (_, record) => (
        <img
          src={record.image}
          alt="User profile"
          style={{ width: 50, height: 50, borderRadius: "50%" }}
        />
      ),
      sortIcon,
    },
    {
      title: "USER NAME",
      dataIndex: "user_name",
      render: (text, record) => (
        <span>{`${record.first_name} ${record.last_name}`}</span>
      ),

      sortIcon,
    },
    {
      title: "PHONE NUMBER",
      dataIndex: "trip",
      render: (text, record) => <span>{`${record.phone}`}</span>,
    },
    {
      title: "STATUS",
      dataIndex: "status",
      render: (text, record) => (
        <Button
          style={{
            backgroundColor: record.is_active ? "#28c76f" : "grey",
            color: "white",
            borderRadius: "15px",
          }}
        >
          {record.is_active ? "Active" : "Not Active"}
        </Button>
      ),
      sortIcon,
    },

    {
      title: "Action",
      render: (text, record) => (
        <PassengerAction 
          user={record} 
          onEdit={() => handleEdit(record)}
        />
      ),
    },
  ];

  return (
    <div className="w-full">
      <div className="w-full px-6 flex flex-wrap-reverse">
        <Input
          className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
          prefix={<SearchOutlined className="mr-2" />}
          placeholder="Search..."
          onChange={handleSearch}
          value={search}
        />
      </div>
      <div className="w-full mt-8 px-4">
        <Table
          loading={loading}
          columns={columns}
          dataSource={data}
          onChange={handlePageChange}
          pagination={{
            total,
            pageSize: per_page,
            current: page,
            nextIcon: (
              <span className="flex items-center justify-center w-8 h-8 text-2xl">
                <NextIcon />
              </span>
            ),
            prevIcon: (
              <span className="flex items-center justify-center w-8 h-8 text-2xl">
                <PreviousIcon />
              </span>
            ),
          }}
        />
      </div>
      {selectedUser && (
        <EditPassengerModal
          visible={editModalVisible}
          user={selectedUser}
          onCancel={() => setEditModalVisible(false)}
          onSuccess={() => {
            setEditModalVisible(false);
            fetchData();
          }}
        />
      )}
    </div>
  );
}

